<template>
  <div class="qta_wrapper" :class="qtype1_valid_cls">
    <b-row>
      <b-col>
        <b-badge variant="primary" class="badgecls">
          정답{{ answer.id }}
        </b-badge>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3"
        ><b-input size="sm" v-model="answer.ansTitle" placeholder="정답제목"
      /></b-col>
      <b-col sm="7">
        <BogiEditor :content="answer.answer" :func="myf" />
      </b-col>
      <b-col>
        <b-button @click="remove" variant="danger" size="sm">D</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import BogiEditor from "@/components/BogiEditor";
export default {
  props: ["answer"],
  components: { BogiEditor },

  computed: {
    myf() {
      return `updateAns${this.answer.id}Text`;
    },
    intent_options() {
      return this.$store.state.intent_options;
    },
    intent_value: {
      get() {
        return this.$store.state.intent_value;
      },
      set(val) {
        this.$state.commit("updateIntent", val);
      },
    },
    qtype1_valid_cls() {
      return this.$store.state.valid.qtype1;
    },
  },
  methods: {
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },
    remove() {
      if (confirm("삭제하시겠습니까?")) {
        this.$store.dispatch("removeQType1Answer", this.answer);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.invalid {
  border: 2px solid red;
}

.qta_wrapper {
  margin-bottom: 15px;
  .multisel_wrapper {
    margin-top: 5px;
  }
  .badgecls {
    padding: 6px;
    margin-bottom: 2px;
  }
}

.multiselect--active {
  z-index: 10;
}
.multiselect__content-wrapper {
  z-index: 10;
}
</style>